import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  PRODUCT_BASKET_PROVIDER_TOKEN,
  PRODUCT_FILTERS_PROVIDER_TOKEN,
  PRODUCT_PROVIDER_TOKEN,
} from '@epicuro-next/data-providers/providers-registry';

import { ProductBasketProviderService } from './services/product-basket-provider';
import { ProductProviderService } from './services/product-provider.service';
import { ProductFiltersProviderService } from './services/product-filters-provider';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: PRODUCT_BASKET_PROVIDER_TOKEN,
      useClass: ProductBasketProviderService,
    },
    {
      provide: PRODUCT_PROVIDER_TOKEN,
      useClass: ProductProviderService,
    },
    {
      provide: PRODUCT_FILTERS_PROVIDER_TOKEN,
      useClass: ProductFiltersProviderService,
    },
    ProductBasketProviderService,
  ],
})
export class ProductProviderModule {}
